// extracted by mini-css-extract-plugin
export default {"signupBox":"signup_signupBox__gIt5z","termsCon":"signup_termsCon__xqM-j","checkboxTermsCon":"signup_checkboxTermsCon__ihCKf"};